import { Navigate } from "react-router-dom";
import { msalInstance } from "../../utils/tokenManager";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const account =
    msalInstance.getActiveAccount() ||
    msalInstance.getAllAccounts()[0];

  const role = sessionStorage.getItem("userRole");

  if (!account) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;